import { GridColDef } from "@mui/x-data-grid";
import { BrandSetting } from "entities/brands/settings/types";
import { BrandTabs } from "entities/pages/types";
import { FC } from "react";
import { generatePath } from "react-router-dom";
import TableWithPagination from "shared/components/TableWithPagination";
import { BRAND_SUB_PAGE_PATH } from "shared/routes/paths";
import { SETTINGS_TAB_STORAGE_KEY } from "../../context";
import { SettingsTabs } from "../../types";

type SearchProps = {
  data: BrandSetting[];
  columns: GridColDef[];
  isLoadingPages: boolean;
  navigate: (path: string) => void;
  brandId: string;
};

const SearchView: FC<SearchProps> = ({
  data,
  columns,
  isLoadingPages,
  navigate,
  brandId,
}) => {
  return (
    <TableWithPagination<BrandSetting>
      data={data}
      columns={columns}
      loading={isLoadingPages}
      emptyStateMessage="No settings found"
      sortingMode="client"
      heightTable={"80vh"}
      hideFooter
      onRowClick={(params) => {
        localStorage.setItem(SETTINGS_TAB_STORAGE_KEY, SettingsTabs.SEARCH);
        return navigate(
          generatePath(BRAND_SUB_PAGE_PATH, {
            id: brandId,
            tabId: BrandTabs.Settings,
            tabDetailsId: String(params.id),
          }),
        );
      }}
    />
  );
};

export default SearchView;
